import { apiFetch, okOrThrow } from './api';

// Assistante d'accueil Atelier Météris — chat de rodage interne (20/10/2026).
// `okOrThrow` : un refus (403, 404, 424, 429…) lève avec `err.status`, jamais un faux succès.
const enJson = (method, body) => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

export const envoyerMessageAccueil = (conversationId, message) =>
  apiFetch('/api/accueil-ia/chat', enJson('POST', { conversation_id: conversationId || null, message })).then(okOrThrow);
